import apiService from "../../services/apiService";
const WISHLIST_API = process.env.REACT_APP_BACKEND_API;

export const getUserWishLists = async () => {
  const res = await apiService.get(`${WISHLIST_API}backend/wishlists`);
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.data?.data)) return res.data.data;

  return [];
};


export const addUserWishList = async (body) => {
  const { data } = await apiService.create(`${WISHLIST_API}backend/wishlists`, body);
  return data?.data;
};


export const removeUserWishList = async (id) => {
  const { data } = await apiService.remove(
    `${WISHLIST_API}backend/wishlists`, 
    id
  );
  return data?.data;
};

